export default "__VITE_ASSET__Bw5X22zT__"